import React, { Component, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@material-ui/core";
import EgretVerticalNavExpansionPanel from "./EgretVerticalNavExpansionPanel";
import { withTranslation, useTranslation } from 'react-i18next';
import localStorageService from "app/services/localStorageService";
import { observer } from "mobx-react";
import { useStore } from "app/stores";
import styles from "./styles.module.scss";
import clsx from "clsx";
import Ripple from "./Component/Ripple";
import ReportEgretVerticalNavExpansionPanel from "./ReportEgretVerticalNavExpansionPanel";
import { isMobile } from "utils";

const ViewEgretVerticalNavExpansionPanel = withTranslation()(EgretVerticalNavExpansionPanel);
const ViewReportEgretVerticalNavExpansionPanel = ReportEgretVerticalNavExpansionPanel;

const RenderLevels = ({data}) => {
  const { t } = useTranslation();

  const [currentOpen, handleCurrentOpen] = useState("");

  const roles = localStorageService.getLoginUser()?.roles?.map((item) => item.authority) || []
  const authUser = localStorageService.getLoginUser() || null
  const shouldRenderLevel = item => {
    if (item.isVisible) {
      if ((!item.auth || roles.some((role) => (item.auth).indexOf(role) !== -1)) &&
        (!item?.detailRole ||  item?.detailRole?.some(detail => authUser?.[detail]))
        || (authUser?.username === "admin" && !item?.isNotAdmin)) {
          return true
        }
    }
    return false
  }
  return data.map((item, index) => {
    if (item.isVisible) {
      if ((!item.auth || roles.some((role) => (item.auth).indexOf(role) !== -1)) &&
        (!item?.detailRole ||  item?.detailRole?.some(detail => authUser?.[detail]))
        || (authUser?.username === "admin" && !item?.isNotAdmin)) {
        return (
          <RenderLevelComponent 
            item={item} 
            index={index} 
            key={index} 
            t={t} 
            // renderLevels={this.renderLevels}
            currentOpen={currentOpen}
            handleCurrentOpen={handleCurrentOpen}
            shouldRenderLevel={shouldRenderLevel}
          />
        )
      }
    }
  });
}

class EgretVerticalNav extends Component {
  // state = {
  //   roles: localStorageService.getLoginUser()?.roles?.map((item) => item.authority) || [],
  //   authUser: localStorageService.getLoginUser() || null,
  // };

  // renderLevels = data => {
  //   const { t } = this.props;
  //   let currentOpen = "";
  //   const handleCurrentOpen = (name) => {
  //     currentOpen = name;
  //   }
  //   return data.map((item, index) => {
  //     if (item.isVisible) {
  //       if ((!item.auth || this.state.roles.some((role) => (item.auth).indexOf(role) !== -1)) &&
  //         (!item?.detailRole ||  item?.detailRole?.some(detail => this.state.authUser?.[detail]))
  //         || (this.state.authUser?.username === "admin" && !item?.isNotAdmin)) {
  //         return (
  //           <RenderLevelComponent 
  //             item={item} 
  //             index={index} 
  //             key={index} 
  //             t={t} 
  //             renderLevels={this.renderLevels}
  //             currentOpen={currentOpen}
  //             handleCurrentOpen={handleCurrentOpen}
  //           />
  //         )
  //       }
  //     }
  //   });
  // };

  render() {
    return (
      <div className="navigation">
        <RenderLevels data ={this.props.navigation} />
        {/* {this.renderLevels(this.props.navigation)} */}
      </div>
    );
  }
}

const RenderLevelComponent = observer(({ 
  item, 
  index, 
  t,
  // renderLevels,
  currentOpen,
  handleCurrentOpen,
  shouldRenderLevel
}) => {
  const { patientStore, patientTransferStore } = useStore()
  const { 
    countSaveEncounter
  } = patientStore;
  const {
    countConfirmTransfer
  } = patientTransferStore;
  //đếm số bệnh nhân chuyển đến, đi chưa tiếp nhận
  const [subTextMenu, setSubTextMenu] = useState();

  useEffect(() => {
    if (item?.callbackForSubTextMenu) {
      //chờ 0.2s để thread trên server chạy rồi mới update lại số
      setTimeout(() => {
        item.callbackForSubTextMenu().then(({ data }) => {
          setSubTextMenu(data);
        })
      }, 200)
    }
  }, [countSaveEncounter, countConfirmTransfer])

  if (item.isReport && !isMobile()) {
    return (
      <ViewReportEgretVerticalNavExpansionPanel 
        item={item}
        key={index}
        shouldRenderLevel={shouldRenderLevel}
      />
    )
  }
  if (item.children) {
    return (
      <ViewEgretVerticalNavExpansionPanel 
        item={item} 
        key={index}
        currentOpen={currentOpen}
        handleCurrentOpen={handleCurrentOpen}
      >
        <RenderLevels data={item.children} />
        {/* {renderLevels(item.children)} */}
      </ViewEgretVerticalNavExpansionPanel>
    );
  } else {
    return (
      <NavLink key={index} to={item.path} className="nav-item">
        <button 
        key={item.name} 
        name="child" 
        className={clsx(styles["touch-ripple"], "w-100")}
        >
          {(() => {
            if (item.icon) {
              return (
                <Icon className="item-icon text-middle">{item.icon}</Icon>
              );
            } else {
              return (
                <span className="item-icon icon-text">{item.iconText}</span>
              );
            }
          })()}
          <span className="text-middle pl-4 item-text left">{`${t(item.name)}`}</span>
          {subTextMenu ?
          <span className="ml-4">(<span className="font-weight-bold text-secondary">{subTextMenu}</span>)</span> 
          : ""}
          <div className="mx-auto"></div>
          {item.badge && (
            <div className={`badge bg-${item.badge.color}`}>
              {item.badge.value}
            </div>
          )}
          <Ripple />
        </button>
      </NavLink>
    );
  }
})

export default EgretVerticalNav;
